<template>

  <div>

  </div>

</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper'
require('@/assets/css/intro.css')

export default {

  created() {
    console.log(window.innerWidth)
    if(window.innerWidth <= 768){
      this.$router.push('/mobile/pages/intro-pulda')
    } else{
      this.$router.push('/pages/intro-pulda')
    }
  },

  mounted() {

  },
  
  data() {
    return {
      currentFilter: 'DOODLES',
      projects: [{
          title: "Artwork",
          image: "https://smtp.filledyou.com/introsub01.png",
          category: 'DOODLES'
        },
        {
          title: "Charcoal",
          image: "https://smtp.filledyou.com/introsub02.png",
          category: 'ART'
        },
        {
          title: "Sketching",
          image: "https://smtp.filledyou.com/introsub03.png",
          category: 'WORKSHOPS'
        },
      ],
      swiperOption: {
        spaceBetween: 30,
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      selectVal: 1,

    }
  },

  // created(){
  //   this.$store.state.fromUrl = ""
  // },
  methods: {
    // gugudan() {
    //   this.$router.push('/pages/gugudan')
    // },
    setFilter: function(filter) {
      this.currentFilter = filter
    },
    goPage() {
      if (!localStorage.getItem("filleduToken") && !sessionStorage.getItem("filleduToken")) {
        this.$router.push('/pages/login')
      } else {
        this.$store.dispatch('auth/fetchAccessToken')
          .then((resolve) => {
            if (resolve.data.result == 'success') {
              const mailIndex = this.adminUserList.findIndex((mail) => mail == this.AppActiveUser.email)
              if (mailIndex != -1) {
                this.$acl.change('admin')
                this.$router.push('/apps/etest')
                return
              }
              this.$acl.change('editor')
              this.$router.push('/apps/space')
            } else {
              this.$router.push('/pages/login')
            }
          }).catch(error => {
            this.$vs.notify({
              title: 'Error',
              text: error.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            this.$router.push('/pages/login')
          })
      }
      // this.$router.push({name: 'LoginForm'})
    },
    // onCommunity () {
    //   this.$emit('goPage', 2)
    // },
    // onProject () {
    //   this.$emit('goPage', 3)
    // }
  },
  computed: {
    AppActiveUser(){
      return this.$store.state.AppActiveUser
    },
    adminUserList(){
      return this.$store.state.adminUserList
    }
  },
  components: {
    swiper,
    swiperSlide
  },
}
</script>

<style scoped>
.title {
  font-size: 38px;
  font-weight: 300;
}

.title2 {
  font-size: 24px;
  font-weight: 300;
}

.title3 {
  font-size: 22px;
  font-weight: 300;
}

.swiper-slide .subtitle {
  font-size: 21px;
}

.swiper-slide .text {
  font-size: 18px;
  max-width: 400px;
  line-height: 1.3;
}

.text {
  font-size: 18px;
  max-width: 400px;
  line-height: 1.5;
}

.project {
  transition: all .35s ease-in-out;
  margin: 10px;
  display: flex;
  align-items: center;
}

.project-image-wrapper {
  position: relative;
}


.project-image {
  width: 680px;
  height: 480px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.project-title {
  font-size: 16pt
}

.filter {
  font-family: arial;
  padding: 6px 6px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.35s;
}

.filter.active {
  box-shadow: 0px 1px 3px 0px #00000026;
}

.filter:hover {
  background: lightgray;
}

.projects {
  width: 680px;
  height: 480px;
  margin-bottom: 50px;
  margin-top: 25px;
  margin-left: 100px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.projects-enter {
  transform: scale(0.5) translatey(-80px);
  opacity: 0;
}

.projects-leave-to {
  transform: translatey(30px);
  opacity: 0;
}

.projects-leave-active {
  position: absolute;
  z-index: -1;
}
</style>
